import React, { useContext, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { FORGOT_ACTIONS } from '../scenes/ForgotScene/ForgotConstants';
import { ForgotContent } from '../scenes/ForgotScene/ForgotContent';
import { UserContext } from '../contexts/UserContext';
import { ForgotContext, ForgotContextProvider } from '../contexts/ForgotContext';
import MainTitle from '../components/MainTitle';
import { PRIMARY } from '../styles/colors';
import { HeaderGap } from '../components/HeaderGap/HeaderGap.styles';

const { SUCCESS } = FORGOT_ACTIONS;

export default function ForgotScene() {
	const { t } = useTranslation();
	const { isLoggedIn } = useContext(UserContext);
	const { dispatch } = useContext(ForgotContext);

	useEffect(() => {
		if (isLoggedIn) {
			dispatch({ type: SUCCESS });
		}
	}, [dispatch, isLoggedIn]);

	return (
		<ForgotContextProvider>
			<HeaderGap>
				<MainTitle title={t('Forgot.Title')} color={PRIMARY} />
				<ForgotContent />
			</HeaderGap>
		</ForgotContextProvider>
	);
}
